<template lang="pug">
.send-message-group-other-user-group-member-detail-modal
  b-modal(ref="modal" size="lg" no-close-on-backdrop no-close-on-esc hide-footer)
    template(#modal-header="{ cancel }")
      .send-message-group-other-user-group-member-detail-modal-header
        span {{ groupName }}
      button.close(type="button" @click="cancel") ×

    .send-message-group-other-user-group-member-detail-modal-table
      .thead
        .header-line
          .th.group-type 種類
          .th.group-name グループ名
          .th.user-name ユーザー名
          .th.organization 所属
      .tbody
        .body-line(v-for="groupMember in _value")
          .td.group-type {{ getGroupType(groupMember.groupTypeId) }}
          .td.group-name {{ groupMember.name }}
          .td.user-name {{ groupMember.memberName }}
          .td.organization {{ groupMember.memberOrganization }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { SenderType } from "@/commons/models/Resident";
import { SendMessageGroupMembersOtherUserGroupMemberGetModel } from "@/commons/services/SendMessageGroupMembers";

/**
 * 宛先グループメンバーリストモーダル
 */
@Component
export default class SendMessageGroupOtherUserGroupMemberDetailModal extends Vue {
  /**
   * 宛先グループメンバー
   */
  @Prop({
    default: () => {
      return [];
    }
  })
  value!: Array<SendMessageGroupMembersOtherUserGroupMemberGetModel>;
  /**
   * 宛先グループ名
   */
  @Prop({
    default: () => {
      return "";
    }
  })
  groupName!: string;
  /** ### 画面表示用のグループ種類名のMAP */
  @Prop()
  groupTypeNameMap!: Map<number, string>;

  /**
   * モーダル表示
   */
  public show(): void {
    const modal: any = this.$refs.modal;
    if (modal) {
      modal.show();
    }

    return;
  }

  get _value(): Array<SendMessageGroupMembersOtherUserGroupMemberGetModel> {
    return this.value;
  }

  public getGroupType(senderType: SenderType): string {
    const groupTypeName: string | undefined = this.groupTypeNameMap.get(senderType);

    return groupTypeName ? groupTypeName : "";
  }
}
</script>
